var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M371.341,35.228c0-14.868-12.165-27.034-27.034-27.034H167.693 c-14.868,0-27.034,12.166-27.034,27.034v441.544c0,14.869,12.165,27.034,27.034,27.034h176.614 c14.868,0,27.034-12.165,27.034-27.034V35.228z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M285.171,283.352c0-3.965-3.243-7.209-7.209-7.209h-43.926c-3.965,0-7.209,3.244-7.209,7.209v14.42 c0,3.966,3.243,7.209,7.209,7.209h43.926c3.965,0,7.209-3.243,7.209-7.209V283.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M215.786,283.352c0-3.965-3.244-7.209-7.209-7.209h-43.926c-3.965,0-7.209,3.244-7.209,7.209v14.42 c0,3.966,3.244,7.209,7.209,7.209h43.926c3.965,0,7.209-3.243,7.209-7.209V283.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M296.214,283.352c0-3.965,3.244-7.209,7.209-7.209h43.926c3.965,0,7.209,3.244,7.209,7.209v14.42 c0,3.966-3.244,7.209-7.209,7.209h-43.926c-3.965,0-7.209-3.243-7.209-7.209V283.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M285.171,327.053c0-3.966-3.243-7.209-7.209-7.209h-43.926c-3.965,0-7.209,3.243-7.209,7.209v14.419 c0,3.966,3.243,7.21,7.209,7.21h43.926c3.965,0,7.209-3.244,7.209-7.21V327.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M215.786,327.053c0-3.966-3.244-7.209-7.209-7.209h-43.926c-3.965,0-7.209,3.243-7.209,7.209v14.419 c0,3.966,3.244,7.21,7.209,7.21h43.926c3.965,0,7.209-3.244,7.209-7.21V327.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M296.214,327.053c0-3.966,3.244-7.209,7.209-7.209h43.926c3.965,0,7.209,3.243,7.209,7.209v14.419 c0,3.966-3.244,7.21-7.209,7.21h-43.926c-3.965,0-7.209-3.244-7.209-7.21V327.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M285.171,370.754c0-3.966-3.243-7.211-7.209-7.211h-43.926c-3.965,0-7.209,3.245-7.209,7.211v14.418 c0,3.966,3.243,7.21,7.209,7.21h43.926c3.965,0,7.209-3.244,7.209-7.21V370.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M215.786,370.754c0-3.966-3.244-7.211-7.209-7.211h-43.926c-3.965,0-7.209,3.245-7.209,7.211v14.418 c0,3.966,3.244,7.21,7.209,7.21h43.926c3.965,0,7.209-3.244,7.209-7.21V370.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M296.214,370.754c0-3.966,3.244-7.211,7.209-7.211h43.926c3.965,0,7.209,3.245,7.209,7.211v14.418 c0,3.966-3.244,7.21-7.209,7.21h-43.926c-3.965,0-7.209-3.244-7.209-7.21V370.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M285.171,414.454c0-3.966-3.243-7.21-7.209-7.21h-43.926c-3.965,0-7.209,3.244-7.209,7.21v14.419 c0,3.966,3.243,7.21,7.209,7.21h43.926c3.965,0,7.209-3.244,7.209-7.21V414.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M215.786,414.454c0-3.966-3.244-7.21-7.209-7.21h-43.926c-3.965,0-7.209,3.244-7.209,7.21v14.419 c0,3.966,3.244,7.21,7.209,7.21h43.926c3.965,0,7.209-3.244,7.209-7.21V414.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M296.214,414.454c0-3.966,3.244-7.21,7.209-7.21h43.926c3.965,0,7.209,3.244,7.209,7.21v14.419 c0,3.966-3.244,7.21-7.209,7.21h-43.926c-3.965,0-7.209-3.244-7.209-7.21V414.454z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FD1E6"
    },
    d: "M344.309,183.693c0,7.929-6.489,14.418-14.418,14.418H182.108c-7.929,0-14.418-6.489-14.418-14.418 V88.995c0-7.93,6.489-14.418,14.418-14.418h147.783c7.929,0,14.418,6.488,14.418,14.418V183.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CC04A"
    },
    d: "M234.409,226.883c0-3.966-3.243-7.21-7.209-7.21h-43.927c-3.965,0-7.208,3.244-7.208,7.21v14.419 c0,3.966,3.243,7.209,7.208,7.209H227.2c3.965,0,7.209-3.243,7.209-7.209V226.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5959"
    },
    d: "M277.591,226.883c0-3.966,3.243-7.21,7.209-7.21h43.927c3.965,0,7.208,3.244,7.208,7.21v14.419 c0,3.966-3.243,7.209-7.208,7.209H284.8c-3.965,0-7.209-3.243-7.209-7.209L277.591,226.883L277.591,226.883z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M205.152,146.43c0.67,0.07,1.445,0,2.502-0.106c1.798-0.247,3.49-0.987,4.793-2.22 c1.515-1.374,2.608-3.384,3.031-6.098h-0.106c-1.268,1.55-3.101,2.467-5.392,2.467c-4.123,0-6.766-3.102-6.766-7.013 c0-4.335,3.137-8.141,7.824-8.141c4.688,0,7.578,3.805,7.578,9.656c0,5.04-1.691,8.564-3.947,10.749 c-1.762,1.727-4.194,2.784-6.661,3.066c-1.128,0.177-2.115,0.212-2.855,0.177L205.152,146.43L205.152,146.43z M206.28,133.25 c0,2.855,1.727,4.863,4.405,4.863c2.079,0,3.701-1.022,4.511-2.396c0.176-0.282,0.282-0.635,0.282-1.128 c0-3.913-1.444-6.907-4.687-6.907C208.148,127.682,206.28,130.008,206.28,133.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M221.15,142.801c0-2.89,1.727-4.934,4.546-6.133l-0.035-0.106c-2.537-1.199-3.63-3.172-3.63-5.145 c0-3.631,3.066-6.098,7.083-6.098c4.44,0,6.661,2.784,6.661,5.639c0,1.938-0.952,4.017-3.77,5.357v0.106 c2.855,1.128,4.617,3.137,4.617,5.921c0,3.982-3.419,6.661-7.789,6.661C224.039,149.003,221.15,146.15,221.15,142.801z  M233.485,142.66c0-2.784-1.938-4.123-5.04-5.004c-2.678,0.775-4.123,2.537-4.123,4.722c-0.106,2.326,1.656,4.37,4.581,4.37 C231.687,146.748,233.485,145.021,233.485,142.66z M224.956,131.205c0,2.291,1.727,3.525,4.37,4.229 c1.973-0.67,3.489-2.079,3.489-4.159c0-1.832-1.093-3.736-3.876-3.736C226.366,127.541,224.956,129.232,224.956,131.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M239.508,148.616v-1.903l2.432-2.362c5.851-5.568,8.494-8.529,8.529-11.982 c0-2.326-1.128-4.476-4.546-4.476c-2.079,0-3.807,1.058-4.863,1.938l-0.987-2.185c1.586-1.34,3.842-2.326,6.484-2.326 c4.934,0,7.013,3.384,7.013,6.66c0,4.229-3.067,7.648-7.895,12.3l-1.833,1.691v0.07h10.291v2.573h-14.625V148.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M258.326,145.057c0.882,0.564,2.925,1.444,5.075,1.444c3.982,0,5.216-2.537,5.181-4.44 c-0.035-3.207-2.925-4.581-5.921-4.581h-1.727v-2.326h1.727c2.255,0,5.11-1.163,5.11-3.876c0-1.832-1.162-3.454-4.017-3.454 c-1.833,0-3.596,0.811-4.581,1.515l-0.811-2.255c1.199-0.882,3.525-1.762,5.992-1.762c4.511,0,6.555,2.678,6.555,5.463 c0,2.362-1.409,4.37-4.229,5.393v0.07c2.82,0.564,5.11,2.679,5.11,5.886c0,3.666-2.855,6.873-8.353,6.873 c-2.572,0-4.828-0.811-5.956-1.55L258.326,145.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M290.888,136.915c0,7.789-2.89,12.088-7.965,12.088c-4.476,0-7.507-4.194-7.578-11.771 c0-7.683,3.313-11.912,7.965-11.912C288.139,125.321,290.888,129.62,290.888,136.915z M278.446,137.268 c0,5.956,1.832,9.339,4.652,9.339c3.172,0,4.687-3.701,4.687-9.55c0-5.639-1.444-9.339-4.652-9.339 C280.42,127.717,278.446,131.029,278.446,137.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M295.537,146.43c0.67,0.07,1.445,0,2.502-0.106c1.798-0.247,3.49-0.987,4.793-2.22 c1.515-1.374,2.608-3.384,3.031-6.098h-0.106c-1.268,1.55-3.101,2.467-5.392,2.467c-4.123,0-6.766-3.102-6.766-7.013 c0-4.335,3.137-8.141,7.824-8.141c4.688,0,7.578,3.805,7.578,9.656c0,5.04-1.691,8.564-3.947,10.749 c-1.762,1.727-4.194,2.784-6.661,3.066c-1.128,0.177-2.115,0.212-2.855,0.177L295.537,146.43L295.537,146.43z M296.664,133.25 c0,2.855,1.727,4.863,4.405,4.863c2.079,0,3.701-1.022,4.511-2.396c0.176-0.282,0.282-0.635,0.282-1.128 c0-3.913-1.444-6.907-4.687-6.907C298.531,127.682,296.664,130.008,296.664,133.25z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#C4E9F2",
      enableBackground: "new"
    },
    d: "M329.892,74.577h-14.701L191.659,198.11h74.091l78.56-78.56 V88.995C344.309,81.065,337.82,74.577,329.892,74.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E252B"
    },
    d: "M242.603,241.303v-14.419c0-8.494-6.909-15.404-15.403-15.404h-43.927 c-8.493,0-15.402,6.911-15.402,15.404v14.419c0,8.493,6.909,15.403,15.402,15.403H227.2 C235.694,256.705,242.603,249.796,242.603,241.303z M226.215,240.317h-41.954v-12.449h41.954V240.317z M256.001,52.651 c7.964,0,14.418-6.456,14.418-14.42c0-7.963-6.454-14.418-14.418-14.418c-7.964,0-14.418,6.455-14.418,14.418 C241.582,46.195,248.037,52.651,256.001,52.651z M328.726,211.48h-43.927c-8.493,0-15.403,6.911-15.403,15.404v14.419 c0,8.493,6.909,15.403,15.403,15.403h43.927c8.493,0,15.402-6.909,15.402-15.403v-14.419 C344.128,218.39,337.219,211.48,328.726,211.48z M327.739,240.317h-41.954v-12.449h41.954V240.317z M344.307,0H167.693 c-19.425,0-35.228,15.803-35.228,35.228v441.544c0,19.425,15.803,35.228,35.228,35.228h176.614 c19.425,0,35.228-15.803,35.228-35.228V35.228C379.535,15.803,363.732,0,344.307,0z M363.146,476.772 c0,10.388-8.451,18.839-18.839,18.839H167.693c-10.388,0-18.839-8.451-18.839-18.839V35.228c0-10.388,8.451-18.839,18.839-18.839 h176.614c10.388,0,18.839,8.451,18.839,18.839V476.772z M329.892,66.383H182.108c-12.468,0-22.612,10.143-22.612,22.612v94.698 c0,12.468,10.143,22.612,22.612,22.612h147.783c12.468,0,22.612-10.143,22.612-22.612V88.995 C352.503,76.526,342.36,66.383,329.892,66.383z M336.115,183.693c0,3.432-2.792,6.223-6.223,6.223H182.108 c-3.432,0-6.223-2.792-6.223-6.223V88.995c0-3.432,2.792-6.223,6.223-6.223h147.783c3.432,0,6.223,2.792,6.223,6.223V183.693z  M274.626,461.07h-37.251c-4.525,0-8.194,3.669-8.194,8.194s3.669,8.194,8.194,8.194h37.251c4.525,0,8.194-3.669,8.194-8.194 C282.82,464.738,279.151,461.07,274.626,461.07z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service-3.5ce3e21e961c980ca809977cf695357b.svg";
export { ForwardRef as ReactComponent };